import React from "react"
import { Form } from "react-bootstrap"
import { FieldArray } from "formik"

const ToggleArrayField = ({ fields, ...props }) => {
  return (
    <FieldArray
      {...fields}
      render={(arrayHelpers) => (
        <Form.Group controlId={fields.name}>
          <Form.Check
            name={
              props.index != undefined ? `${fields.name}.${props.index}` : ""
            }
            type="checkbox"
            label={props.label}
            onChange={(e) => {
              props.index != undefined && !e.target.checked
                ? arrayHelpers.remove(props.index)
                : arrayHelpers.push(props.body)
            }}
            checked={props.index != undefined}
            disabled={props.disabled}
          />
        </Form.Group>
      )}
    />
  )
}

export default ToggleArrayField
